import { GET_ALL_OBJECTIONS } from 'src/api/graphql/queries/objections.gql';
import { fetchList } from './fetchLists';
import {
	pickFilters,
	prepareGraphqlFilters,
} from 'src/utils/helpers/prepareGraphqlFilters';

export const getAllObjections = async ({
	page = 1,
	limit = 15,
	sort,
	filters,
} = {}) => {
	return fetchList({
		query: GET_ALL_OBJECTIONS,
		variables: {
			page,
			limit,
			sort,
			filters: pickFilters(prepareGraphqlFilters(filters), [
				'id',
				'company',
				'companyGorkoId',
				'companyName',
				'createdBy',
				'createdByName',
				'type',
				'typeName',
				'solved',
				'solvedAt',
				'comment',
				'createdAt',
			]),
		},
		addPerPage: true,
	});
};
